module.exports = __webpack_public_path__ + "img/tff-teamtip@2x.91754d84.png";